export const tr = {
    email: 'Eposta',
    password: 'Şifre',
    login_btn: 'Giriş',
    search_placeholder: 'arama yap...',
};